function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fb0f3b",
  d: "M28.26 26.47l-4.64-4.64a11.35 11.35 0 1 0-1.79 1.79l4.64 4.64a1.27 1.27 0 1 0 1.79-1.79zm-7.16-5.6L21 21l-.11.12a8.82 8.82 0 1 1 .23-.23z",
  "data-name": "Overview"
});

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHRpdGxlPkNhbGVuZGx5IE92ZXJ2aWV3PC90aXRsZT4KICA8ZyBpZD0iOThkYzgwMmMtYWJmZi00YWM5LWI0MmUtNmY1YWQ4N2ViMWMwIiBkYXRhLW5hbWU9Ik92ZXJ2aWV3Ij4KICAgIDxwYXRoIGZpbGw9JyNmYjBmM2InIGQ9Ik0yOC4yNiwyNi40N2wtNC42NC00LjY0YTExLjM1LDExLjM1LDAsMSwwLTEuNzksMS43OWw0LjY0LDQuNjRhMS4yNywxLjI3LDAsMSwwLDEuNzktMS43OVptLTcuMTYtNS42TDIxLDIxbC0uMTEuMTJhOC44Miw4LjgyLDAsMSwxLC4yMy0uMjNaIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgComponent as ReactComponent };